import api from "../../../shared/api/client";

export async function getPoolPage({
  page = 1,
  pageSize = 20,
  status,
  channel,
  search,
} = {}) {
  const params = { page, pageSize };
  if (status) params.status = status;
  if (channel) params.channel = channel;
  if (search) params.search = search;
  const { data } = await api.get("/pool", { params });
  return data;
}

export async function getPoolItem(id) {
  const { data } = await api.get(`/pool/${id}`);
  return data;
}

export async function updatePoolItem(id, body) {
  const { data } = await api.patch(`/pool/${id}`, body);
  return data;
}

export async function deletePoolItem(id) {
  const { data } = await api.delete(`/pool/${id}`);
  return data;
}

export async function createPoolItem(body) {
  const { data } = await api.post("/pool", body);
  return data;
}
